/** P-T3NUDGE — Task 3 silence nudge eligibility (monologue, one nudge per attempt). */

/** Owner-approved 2026-09-19 (was 10s → 7s experiment → 6s after WS delay observation). */
export const TASK3_NUDGE_SILENCE_SECONDS = 6;
export const TASK3_NUDGE_FINAL_PHASE_SECONDS = 45;

/** Client→server keepalive during Task 3 monologue silence (avoids proxy idle drop before server heartbeat). */
export const TASK3_WS_KEEPALIVE_INTERVAL_MS = 8_000;

export type Task3NudgeEligibilityInput = {
  userHasEverSpoken: boolean;
  elapsedSilenceSeconds: number;
  remainingSeconds: number;
  nudgeAllowanceConsumed: boolean;
};

export function shouldRequestTask3Nudge(input: Task3NudgeEligibilityInput): boolean {
  if (!input.userHasEverSpoken) return false;
  if (input.nudgeAllowanceConsumed) return false;
  if (input.remainingSeconds <= TASK3_NUDGE_FINAL_PHASE_SECONDS) return false;
  return input.elapsedSilenceSeconds >= TASK3_NUDGE_SILENCE_SECONDS;
}

/** Monotonic claim: false → true only; never true → false within the same attempt. */
export function tryConsumeTask3NudgeAllowance(state: {
  nudgeAllowanceConsumed: boolean;
}): boolean {
  if (state.nudgeAllowanceConsumed) return false;
  state.nudgeAllowanceConsumed = true;
  return true;
}

export function createFreshTask3NudgeAllowanceState(): {
  nudgeAllowanceConsumed: boolean;
} {
  return { nudgeAllowanceConsumed: false };
}
